import { useEffect, useRef } from 'react'
import { usePage } from '@inertiajs/react'
import { useTranslation } from 'react-i18next'
import { useNotificationContext } from '@contexts/NotificationContext'
import { ToastType } from './Toast'

interface FlashData {
  key: string
  [key: string]: any
}

interface FlashMessages {
  success?: FlashData | string
  error?: FlashData | string
  warning?: FlashData | string
  info?: FlashData | string
}

export default function FlashToastMonitor() {
  const { t } = useTranslation()
  const { flash } = usePage<{ flash: FlashMessages }>().props
  const { showToast } = useNotificationContext()
  const shownFlashIds = useRef<Set<string>>(new Set())

  const getMessage = (message: FlashData | string): string => {
    if (typeof message === 'string') {
      return message
    }
    const { key, ...params } = message
    return String(t(key, params))
  }

  useEffect(() => {
    if (!flash) return

    Object.entries(flash).forEach(([type, message]) => {
      if (!message) return

      const flashId = `flash-${type}-${JSON.stringify(message)}`

      if (shownFlashIds.current.has(flashId)) return

      shownFlashIds.current.add(flashId)

      const toastType = type as ToastType
      const messageText = getMessage(message)

      showToast(toastType, messageText, {
        duration: type === 'error' ? 5000 : 3000,
        dismissible: true
      })
    })
  }, [flash, showToast])

  return null
}
